<script lang="ts">

  let { class: className = "" } = $props()
</script>
<svg class="{className} spinner" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M479.76-120q-74.07 0-139.65-28.3-65.58-28.3-114.55-77.26-48.96-48.97-77.26-114.55Q120-405.69 120-479.76q0-74.96 28.42-140.45 28.43-65.48 77.16-114.21 48.73-48.73 114.59-77.16Q406.02-840 480-840q8.5 0 14.25 5.76t5.75 14.27q0 8.51-5.75 14.24T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-8.54 5.76-14.27t14.27-5.73q8.51 0 14.24 5.75T840-480q0 73.98-28.42 139.83-28.43 65.86-77.16 114.59-48.73 48.73-114.21 77.16Q554.72-120 479.76-120Z"/></svg>


<style lang=postcss>
  .spinner {
    animation-name: spin;
    animation-duration: 1200ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    transform-box: view-box;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
      transform-origin: center center;
    }
  }
</style>
